/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SourcingSearchFreelancerVertical = {
    Regular: 'REGULAR',
    Strategy: 'STRATEGY'
} as const;
export type SourcingSearchFreelancerVertical = typeof SourcingSearchFreelancerVertical[keyof typeof SourcingSearchFreelancerVertical];


export function instanceOfSourcingSearchFreelancerVertical(value: any): boolean {
    for (const key in SourcingSearchFreelancerVertical) {
        if (Object.prototype.hasOwnProperty.call(SourcingSearchFreelancerVertical, key)) {
            // @ts-ignore
            if (SourcingSearchFreelancerVertical[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SourcingSearchFreelancerVerticalFromJSON(json: any): SourcingSearchFreelancerVertical {
    return SourcingSearchFreelancerVerticalFromJSONTyped(json, false);
}

export function SourcingSearchFreelancerVerticalFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchFreelancerVertical {
    return json as SourcingSearchFreelancerVertical;
}

export function SourcingSearchFreelancerVerticalToJSON(value?: SourcingSearchFreelancerVertical | null): any {
    return value as any;
}

